import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const InstitutionContext = createContext(null);

const API_URL = process.env.REACT_APP_API_URL || '';

export function InstitutionProvider({ children }) {
  const { institutionSlug } = useParams();
  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!institutionSlug) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/v1/assessathon-admin/public/institutions/${institutionSlug.toLowerCase()}`)
      .then(async r => {
        const data = await r.json();
        if (!r.ok) {
          // Return the server's error message or a default one
          throw new Error(data.detail || 'Institution not found');
        }
        return data;
      })
      .then(data => { setInstitution(data); setError(null); })
      .catch(err => { setError(err.message || 'Failed to load institution'); })
      .finally(() => setLoading(false));
  }, [institutionSlug]);

  return (
    <InstitutionContext.Provider value={{ institution, loading, error, slug: institutionSlug }}>
      {children}
    </InstitutionContext.Provider>
  );
}

export function useInstitution() {
  return useContext(InstitutionContext);
}
